import { useNavigate } from 'react-router';

const MealTracker = () => {
  const navigate = useNavigate();

  return (
    <button
      className='bg-secondary rounded-xl p-4'
      onClick={() => navigate('/meal')}
    >
      <div className='flex items-center gap-4 mb-4'>
        <h2 className='text-lg font-semibold'>Meal Log</h2>
      </div>
      <p className='text-sm text-gray-400 mb-4 text-left'>Go to meal tracker</p>
    </button>
  );
};

export default MealTracker;
